import DropTablesNav from "./DropTablesNav";
import AdLayout from "../../app-core/AdLayout";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";

type Tables = Array<[number, Array<[string, number | undefined]>]>;

export default function MagicRollTables({
  tables: _,
}: {
  tables: { loot: Tables };
}) {
  const tables: any = [
    [
      0.36,
      [
        ["ThreeCostUnitTwoStarUnit"],
        ["ThreeCostUnitTwoStarUnit"],
        ["TwoCostUnitTwoStarUnit"],
      ],
    ],
    [
      0.32,
      [
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["COMPONENT_NOSPAT"],
        ["REFORGER"],
      ],
    ],
    [0.25, [["HP", 250]]],
    [
      0.04,
      [["TFT_Item_FryingPan"], ["COMPONENT_NOSPAT"], ["COMPONENT_NOSPAT"]],
    ],
    [
      0.014,
      [
        ["Gold", 6],
        ["LesserDuplicator"],
        ["LesserDuplicator"],
        ["LesserDuplicator"],
      ],
    ],
    [0.014, [["TACTICIANSCROWN"]]],
    [0.005, [["GoldenEgg"]]],
  ];

  return (
    <AdLayout>
      <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
        <DropTablesNav route={"Magic Roll"} />
        <h2 className="h2 p-4 pb-8 flex items-center gap-1">
          {T.augments("MagicRoll")}
        </h2>
        <LootGrid data={tables} />
      </div>
    </AdLayout>
  );
}
